import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { observer } from 'mobx-react';
import * as Yup from 'yup';
import { ErrorMessage, Formik } from 'formik';
import stores from '../../../stores';
import Btn from '../../buttons/Btn';
import { Title } from './Title';
import Field from '../../fields/Field';
import { ERROR_COLOR } from '../../../theme';

const Container = styled.div`
  margin-bottom: 40px;
`;

const BtnContainer = styled.div`
  margin-top: 27px;
  max-width: 384px;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.57;
  letter-spacing: 0.3px;
  margin: 16px 0 8px;
  ${(props) => props.error && `color: ${ERROR_COLOR};`}
`;

const SmallInput = styled.div`
  max-width: 384px;
  width: 100%;
`;

const ErrorMessageContainer = styled.div`
  color: ${ERROR_COLOR};
  font-size: 12px;
  line-height: 1.17;
  margin-top: 3px;
`;

const validationSchema = Yup.object().shape({
  phone: Yup.string()
    .matches(
      /^(?:(?:)0)\s*[1-9](?:\s*\d{2}){4}$/,
      'Le téléphone doit être au format 01 23 45 67 89'
    )
    .required('Ce champ est obligatoire.'),
});

const formInitialValues = {
  phone: '',
};

const LoggedInPayment = observer(({ togglePaymentForm, cost }) => {
  const { prenom: Name, nom: Surname, phone } = stores.userStore.userInfo;
  const { isPaymentDataLoading } = stores.theoryAccessStore;
  const onSubmit = async (data, formikBag) => {
    try {
      await stores.userStore.setUser(data, formikBag);
      togglePaymentForm();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  return (
    <div>
      <Container>
        <Title>Mes coordonnées</Title>
        <div>{`${Name} ${Surname}`}</div>
        {phone ? (
          <>
            <div>{phone}</div>
            <BtnContainer>
              <Btn
                isLoading={isPaymentDataLoading}
                disabled={isPaymentDataLoading}
                type="submit"
                text={`Paiement (${cost}€)`}
                name="payBtn"
                block
                onClick={togglePaymentForm}
              />
            </BtnContainer>
          </>
        ) : (
          <Formik
            initialValues={formInitialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              values,
              handleSubmit,
              errors,
              touched,
              handleChange,
              handleBlur,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <Label error={touched.phone && errors.phone}>Téléphone</Label>
                <SmallInput>
                  <Field
                    value={values.phone}
                    name="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="0601020304"
                    valid={touched.phone && !errors.phone}
                  />
                </SmallInput>
                <ErrorMessage component={ErrorMessageContainer} name="phone" />
                <BtnContainer>
                  <Btn
                    isLoading={isSubmitting || isPaymentDataLoading}
                    disabled={isSubmitting || isPaymentDataLoading}
                    type="submit"
                    text={`Paiement (${cost}€)`}
                    name="payBtn"
                    block
                  />
                </BtnContainer>
              </form>
            )}
          </Formik>
        )}
      </Container>
    </div>
  );
});

LoggedInPayment.propTypes = {
  togglePaymentForm: PropTypes.func.isRequired,
  cost: PropTypes.string.isRequired,
};

export { LoggedInPayment };
